export const TAB = {
  ARTICLES: "articles",
  DOCUMENTATION: "documentation",
  TALKS: "talks",
};
